import { render, staticRenderFns } from "./prodRecommend.vue?vue&type=template&id=840a07a0&scoped=true&"
import script from "./prodRecommend.vue?vue&type=script&lang=js&"
export * from "./prodRecommend.vue?vue&type=script&lang=js&"
import style0 from "./prodRecommend.vue?vue&type=style&index=0&id=840a07a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840a07a0",
  null
  
)

export default component.exports